import { render } from "./AboutComponent.vue?vue&type=template&id=613a8ebe"
import script from "./AboutComponent.vue?vue&type=script&lang=js"
export * from "./AboutComponent.vue?vue&type=script&lang=js"
script.render = render

export default script